import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { getWebBoosterVairant } from '../../../constants/webBoosterType';
import { WebBoosterType } from '../../../models/UserStore';
import { SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './AboutDailyPracticePopup.module.css';

type AboutDailyPracticePopupProps = {
  webBoosterType: WebBoosterType | undefined;
  onCancel: () => void;
};

export const AboutDailyPracticePopup = (
  props: AboutDailyPracticePopupProps,
) => {
  const { t } = useTranslation();
  const { webBoosterType, onCancel } = props;

  return (
    <BasicPopupContainer
      primaryButtonLabel={t('OK')}
      onPrimaryButtonClick={onCancel}
    >
      <div className={styles.popupContent}>
        <SvgIcon
          name={SVGIconType.MemoryWithAI}
          width={80}
          height={80}
          color={'#333'}
          style={{ margin: '0 auto' }}
        />
        <div>
          <div className={styles.greenTitle}>
            {t(getWebBoosterVairant(webBoosterType).name)}
          </div>
          <div className={styles.title}>
            {t('Auto-Scheduled Daily Practice')}
          </div>
        </div>

        <hr />

        <div className={styles.learningMethodRow}>
          <SvgIcon
            name={SVGIconType.BubbleShape}
            className={styles.redBubble}
          />
          <div className={styles.vContainer}>
            <div className={styles.description}>
              {t('Memorize Something Important')}
            </div>
            <div className={styles.learningText}>
              {t(
                'Provide Auto-Scheduled Daily Practice to help you memorize something important forever.',
              )}
            </div>
          </div>
        </div>

        <div className={styles.learningMethodRow}>
          <SvgIcon
            name={SVGIconType.BubbleShape}
            className={styles.orangeBubble}
          />
          <div className={styles.vContainer}>
            <div className={styles.description}>
              {t('Develop Cognitive Skills')}
            </div>
            <div className={styles.learningText}>
              {t(
                'Auto-Scheduled Daily Practice help you develop your preferred mindset, behaviour and responses to different situations.',
              )}
            </div>
          </div>
        </div>

        <div className={styles.learningMethodRow}>
          <SvgIcon
            name={SVGIconType.BubbleShape}
            className={styles.greenBubble}
          />
          <div className={styles.vContainer}>
            <div className={styles.description}>
              {t('Strengthen Your Brain')}
            </div>
            <div className={styles.learningText}>
              {t(
                'When you try to memorize more in Auto-Scheduled Daily Practice, the memory power of your brain is also strengthened.',
              )}
            </div>
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
